module.exports = __webpack_public_path__ + "static/img/eye_close.566266e7.svg";